(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hallmark-anatomy"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hm-anatomy').forEach((root) => {
    const setActive = (i) => {
      root.querySelectorAll('[data-hm-hot]').forEach((h) => h.classList.toggle('is-active', h.dataset.hmHot === i));
      root.querySelectorAll('[data-hm-item]').forEach((it) => {
        const on = it.dataset.hmItem === i;
        it.classList.toggle('is-active', on);
        it.setAttribute('aria-expanded', String(on));
      });
    };
    root.addEventListener('click', (e) => {
      const hit = e.target.closest('[data-hm-hot], [data-hm-item]');
      if (!hit) return;
      setActive(hit.dataset.hmHot ?? hit.dataset.hmItem);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hallmark-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.classList.add('js');

  document.querySelectorAll('[data-hm-filters]').forEach((bar) => {
    const panel = bar.querySelector('.hm-fpanel');
    const form = bar.querySelector('.hm-fpanel__body');

    // With scripting on, the Apply button is hidden, so a tick applies straight
    // away. Price inputs wait for Enter or blur rather than firing per keystroke.
    form?.addEventListener('change', (event) => {
      if (event.target.type === 'checkbox') form.requestSubmit
        ? form.requestSubmit()
        : form.submit();
    });
    form?.querySelectorAll('.hm-fprice input').forEach((input) => {
      input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); form.submit(); } });
    });

    // Clicking away or pressing Escape closes the panel.
    document.addEventListener('click', (event) => {
      if (panel?.open && !panel.contains(event.target)) panel.open = false;
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel?.open) { panel.open = false; panel.querySelector('.hm-fbtn')?.focus(); }
    });

    bar.querySelectorAll('[data-hm-sort] select').forEach((select) => {
      select.addEventListener('change', () => select.form.submit());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hallmark-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Browsers that support <details name> group the panels natively; only the
    // rest need this. `toggle` does not bubble, so listen in the capture phase.
    if ('name' in document.createElement('details')) return;
    document.addEventListener('toggle', (event) => {
      const panel = event.target;
      if (!(panel instanceof HTMLDetailsElement) || !panel.open) return;
      const list = panel.closest('.hm-faq__list');
      if (!list) return;
      list.querySelectorAll('details[open]').forEach((other) => {
        if (other !== panel) other.open = false;
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hallmark-flagship"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hm-flagship]').forEach((root) => {
    const panels = () => root.querySelectorAll('[data-hm-panel]');
    const ways = [...root.querySelectorAll('[data-hm-way]')];
    const sizes = [...root.querySelectorAll('[data-hm-size]')];
    let way = root.dataset.openWay;
    let size = root.dataset.openSize;

    const sizesFor = (w) => (ways.find((b) => b.dataset.hmWay === w)?.dataset.hmSizes || '').split(',');

    const paint = () => {
      const available = sizesFor(way);
      // A colourway we cannot supply in the current size falls back rather than
      // showing an empty stage.
      if (!available.includes(size)) size = available[0];

      ways.forEach((b) => {
        const on = b.dataset.hmWay === way;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', String(on));
      });
      sizes.forEach((b) => {
        const on = b.dataset.hmSize === size;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', String(on));
        b.disabled = !available.includes(b.dataset.hmSize);
      });
      panels().forEach((p) => { p.hidden = p.dataset.hmPanel !== way + '-' + size; });
    };

    root.addEventListener('click', (e) => {
      const w = e.target.closest('[data-hm-way]');
      const s = e.target.closest('[data-hm-size]');
      const t = e.target.closest('[data-hm-thumb]');
      if (w) { way = w.dataset.hmWay; paint(); return; }
      if (s && !s.disabled) { size = s.dataset.hmSize; paint(); return; }
      if (t) {
        const panel = t.closest('[data-hm-panel]');
        const i = t.dataset.hmThumb;
        panel.querySelectorAll('[data-hm-shot]').forEach((sh) => sh.classList.toggle('is-active', sh.dataset.hmShot === i));
        panel.querySelectorAll('[data-hm-thumb]').forEach((th) => th.classList.toggle('is-active', th === t));
        const counter = panel.querySelector('[data-hm-index]');
        if (counter) counter.textContent = String(Number(i) + 1);
      }
    });

    paint();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hallmark-header"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-hm-drawer]');
    if (!drawer) return;
    const open = document.querySelector('[data-hm-menu-open]');
    const close = document.querySelector('[data-hm-menu-close]');
    const setOpen = (isOpen) => {
      drawer.hidden = !isOpen;
      document.documentElement.style.overflow = isOpen ? 'hidden' : '';
      if (open) open.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) { const f = drawer.querySelector('a, button'); if (f) f.focus(); }
      else if (open) open.focus();
    };
    open?.addEventListener('click', () => setOpen(true));
    close?.addEventListener('click', () => setOpen(false));
    drawer.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) setOpen(false); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hallmark-product-buybox"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Gallery: thumbnails swap the hero without a page load.
    document.querySelectorAll('.hm-buy__thumbs').forEach((strip) => {
      const hero = strip.closest('.hm-buy__media')?.querySelector('.hm-buy__hero');
      if (!hero) return;
      strip.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-hm-thumb]');
        if (!thumb) return;
        const full = thumb.dataset.full;
        if (full) { hero.srcset = ''; hero.src = full; }
        strip.querySelectorAll('[data-hm-thumb]').forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    });

    // Sticky bar appears once the real add-to-cart button scrolls out of view.
    const bar = document.querySelector('[data-hm-stickybuy]');
    const atc = document.querySelector('.hm-buy__atc');
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        ([entry]) => { bar.hidden = entry.isIntersecting; },
        { rootMargin: '0px 0px -40px 0px' }
      ).observe(atc);
      bar.querySelector('[data-hm-sticky-atc]')?.addEventListener('click', () => atc.click());
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
